/**
 * Filter Type Definitions
 *
 * This file contains type definitions and enums for order filters.
 * These are shared across multiple files (atoms, components, utilities).
 */

/**
 * Date range for delivery date filters
 */
export enum DeliveryDateFilter {
	TODAY = 'today',
	THIS_WEEK = 'this-week',
	NEXT_2_WEEKS = 'next-2-weeks',
	THIS_MONTH = 'this-month',
	NEXT_MONTH_AND_BEYOND = 'next-month-and-beyond',
	CUSTOM = 'custom',
}
